import React, { useState } from 'react';
import { observer } from 'mobx-react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

const BroadcastMessage = observer((props) => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    

    const nextMessage = () => {
        if(currentMessageIndex + 1 >= props.store.SessionStore.matchingBroadcasts.length){
            props.noMatchingBroadcast();
        }else{
            setCurrentMessageIndex((prevIndex) =>
                prevIndex === props.store.SessionStore.matchingBroadcasts.length - 1 ? 0 : prevIndex + 1
            );
        }        
    };

    const setSelectedBroadcastMessage = (message) => {
        props.store.SessionStore.selectedBroadcastMessage = message;
    };

    const messageCard = (message) => {
        return (
        <Card>
          <Card.Body>
            <Card.Title>{message.title}</Card.Title>
            <Card.Text dangerouslySetInnerHTML={{ __html: message.details }} className="pb-2" />
            {!props.store.SessionStore.selectedBroadcastMessage ? (
                <>
                    <Card.Text className="text-center pt-3 border-top">
                        Contacting support about this issue?
                    </Card.Text>
                    <Card.Text className="text-center">
                        <Button variant="secondary" onClick={nextMessage} className="me-3">No</Button>
                        <Button variant="primary" onClick={() => setSelectedBroadcastMessage(message)}>Yes</Button>
                    </Card.Text>
                </>
                ) : (
                    <Card bg="light">
                        <Card.Body>
                        <Card.Title>Resolution Information</Card.Title>
                        <Card.Text dangerouslySetInnerHTML={{ __html: message.resolutionInformation }} className="pb-3" />
                        {!message.disableChat ? (
                            <Card.Text className="text-center">
                                <Button variant="primary" onClick={() => props.noMatchingBroadcast()}>This did not help</Button>
                            </Card.Text>
                        ) : (<></>)}
                         </Card.Body>
                    </Card>
                    )}
          </Card.Body>
        </Card>
      );
    };

  return (
            <>
                <p>We found <strong>{ props.store.SessionStore.matchingBroadcasts.length } ongoing {props.store.SessionStore.matchingBroadcasts.length > 1 ? (<>issues</>) : (<>issue</>)} that may impact you</strong>. Please review {props.store.SessionStore.matchingBroadcasts.length > 1 ? (<>each issue</>) : (<>the issue</>)} below before proceeding.</p>
                {messageCard(props.store.SessionStore.matchingBroadcasts[currentMessageIndex])}
            </>
  );
});

export default BroadcastMessage;